import {BottomBar as BottomBarSrc} from './BottomBar'
import {ColumnBar} from '..';

export const BottomBar = Object.assign(BottomBarSrc, ColumnBar);
